import React from 'react';
import { Redirect } from 'react-router';

export const UserWorkMode = React.createContext();

export const WorkModeProvider = ({ value, children }) => (
  <UserWorkMode.Provider value={value}>{children}</UserWorkMode.Provider>
);

export const WorkMode = ({ match, children }) => (
  <UserWorkMode.Consumer>
    {(mode) => {
      if (typeof match === 'undefined') return children(mode);
      if (Array.isArray(match) && match.indexOf(mode) !== -1) return children(mode);
      if (match === mode) return children(mode);
      return null;
    }}
  </UserWorkMode.Consumer>
);

export const withWorkMode = (Component) => (props) => (
  <UserWorkMode.Consumer>{(mode) => <Component {...props} mode={mode} />}</UserWorkMode.Consumer>
);

export const WorkModeSwitch = ({ solo, teamMember, teamFounder }) => (
  <UserWorkMode.Consumer>
    {(mode) => {
      switch (mode) {
        case 'SOLO':
          return solo ? solo : <Redirect to="/" />;
        case 'TEAM_MEMBER':
          return teamMember ? teamMember : <Redirect to="/" />;
        case 'TEAM_FOUNDER':
          return teamFounder ? teamFounder : <Redirect to="/" />;
        default:
          return <Redirect to="/" />;
      }
    }}
  </UserWorkMode.Consumer>
);
